export const LOGIN_SIGNIN = 'LOGIN_SIGNIN';
export const LOGIN_SIGNEDIN = 'LOGIN_SIGNEDIN';
export const LOGIN_SIGNOUT = 'LOGIN_SIGNOUT';
export const LOGIN_SIGNEDOUT = 'LOGIN_SIGNEDOUT';
export const LOGIN_CHANGE_PHONE = 'LOGIN_CHANGE_PHONE';
